<template>
  <section
    ref="section"
    class="three-blocks-module-component">
    <div class="blocks">
      <div
        v-for="(block, idx) in data.blocks_items"
        :key="`block-${idx}`"
        class="block"
        :class="{
          'big-box': data.big_box_mobile,
          // 'active-address-box': idx === activeItem,
        }">
        <img
          :src="block.img.url"
          alt="" />
        <div
          ref="textItems"
          class="text-container">
          <span
            class="title"
            v-html="block.text" />
          <span
            v-if="block.sub"
            class="sub"
            v-html="block.sub" />
          <span
            v-if="block.full_text"
            class="divider"
            :class="{ 'more-padding': !block.sub }" />
          <div
            v-if="block.full_text"
            class="text"
            v-html="block.full_text" />
        </div>
      </div>
    </div>
    <Map
      v-if="data.map"
      :data="data.blocks_items" />
  </section>
</template>

<script setup>
/* #META
 {
  "NAME": "ThreeBlocksComponent",
  "CLASSNAME": "three-blocks-module-component",
  "URL": "http://lifemine.local/templates/"
 }
#ENDMETA */
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
import useUtils from '@/composables/useUtils'
import useMapActiveItem from '@/composables/useMapActiveItem'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Map from '@/components/utility/MapModule.vue'
gsap.registerPlugin(ScrollTrigger)

const { activeItem, setActive } = useMapActiveItem()
const props = defineProps(['data'])
const { device, genUUID } = useUtils()
const animID = ref(genUUID())
const section = ref()
const textItems = ref()

watch(activeItem, () => {
  if (activeItem.value !== -1) {
    window.open(props.data.blocks_items[activeItem.value].maps_link, '_blank')
  }
})

const sectionAnim = () => {
  gsap.fromTo(
    textItems.value,
    {
      y: -30,
    },
    {
      y: 30,
      scrollTrigger: {
        trigger: section.value,
        scrub: true,
        start: 'top+=100px center+=20%',
        end: `bottom+=100px top`,
        // markers: true,
        id: animID.value,
      },
    }
  )
}

onMounted(() => {
  setActive(-1)
  if (device.value === 'desktop' && !props.data.map) sectionAnim()
})

onBeforeUnmount(() => {
  const anim = ScrollTrigger.getById(animID.value)
  if (anim) anim.kill()
})
</script>

<style lang="scss">
.three-blocks-module-component {
  .blocks {
    @apply flex flex-col lg:flex-row w-full;
  }
  .block {
    @apply transition-all relative overflow-hidden h-[280px] flex flex-col justify-center items-center lg:w-1/3 lg:h-[480px];
    @apply transition-all duration-500;

    &.big-box {
      @apply h-[305px] lg:h-[480px];
      .text-container {
        @apply w-[66%] flex flex-col items-center backdrop-blur-md p-4 bg-black/10;
      }
    }

    .text-container {
      @apply w-[62%] flex flex-col items-center backdrop-blur-md p-4 bg-black/10;
    }

    &.active-address-box {
      @apply bg-lm_orange/30;
    }

    img {
      @apply absolute -z-1 w-full h-full object-cover;
    }

    .title {
      @apply heading-4 text-lm_white text-center;
    }

    .sub {
      @apply small text-lm_white text-center mt-[10px];
    }

    .divider {
      @apply w-8 h-[3px] bg-lm_white my-3;

      &.more-padding {
        @apply my-[26px];
      }
    }

    .text {
      @apply small flex flex-col gap-[10px];

      p {
        @apply text-lm_white text-center;
      }
    }
  }
}
</style>
